import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LocaleConfig } from './config';
import { isAppLanguage } from './is-app-language';
import { type AppLanguage, appLanguages, supportedAppLanguagesNames } from './supported-app-languages-names';

export type LocaleCode = 'en-US' | 'es-ES';

const localeCodes: Record<AppLanguage, LocaleConfig<LocaleCode>> = {
  [appLanguages.english]: {
    locale: 'en-US',
    name: supportedAppLanguagesNames[appLanguages.english].name,
  },
  [appLanguages.spanish]: {
    locale: 'es-ES',
    name: supportedAppLanguagesNames[appLanguages.spanish].name,
  },
};

export const useLocaleCode = () => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const localeCode = isAppLanguage(i18n.language)
      ? localeCodes[i18n.language].locale
      : localeCodes[appLanguages.english].locale;

    return localeCode;
  }, [i18n.language]);
};
